<mat-card
    (click)="onServiceSelected()"
    [class]="
        selected
            ? '!border-primary-700 !border-2 !bg-primary-50 border-'
            : hasErrorHighlight
              ? '!border-error-700 !border-2 !bg-neutral-100'
              : '!bg-neutral-100'
    "
    class="flex flex-col justify-between !rounded-md"
    [class.cursor-pointer]="!disabled"
>
    <mat-card-header class="text-left w-full mb-2">
        <mat-card-title>
            <span class="text-base text-tertiary-900 font-medium">{{
                formOption.title
            }}</span>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="text-left w-full">
        <p class="text-sm" [innerHTML]="formOption.description"></p>
    </mat-card-content>
</mat-card>
